export default __webpack_public_path__ + "static/Alvin-71f31a8e8ee015fe1f9f0e5a78841612c100bf72b164f1a250a9fbc1b420c776.svg";